<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
    <v-container>
      <v-row>
        <v-col cols="3">名稱</v-col>
        <v-col cols="9">
          <v-text-field
            label="名稱"
            required
            v-model="dialogInfo.merchantName"
            :rules="merchantNameRule"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">類別</v-col>
        <v-col cols="9">
          <v-select
            :items="categorySelectForm"
            label="類別"
            v-model="dialogInfo.categoryId"
            item-text="text"
            item-value="value"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">識別碼</v-col>
        <v-col cols="9">
          <v-text-field
            label="識別碼"
            required
            v-model="dialogInfo.merchantCode"
            :rules="merchantCodeRule"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">序號圖案</v-col>
        <v-col cols="9">
          <v-select
            label="序號圖案"
            :items="voucherDisplayTypes"
            item-text="text"
            item-value="value"
            v-model="dialogInfo.displayType"
            :rules="typeRule"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">序號產生機制</v-col>
        <v-col cols="9">
          <v-select
            label="序號產生機制"
            :items="VoucherGenerationMethods"
            item-text="text"
            item-value="value"
            v-model="dialogInfo.voucherGenerationMethod"
            :rules="typeRule"
            :disabled="isAnyProducts"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">產品最低手續費</v-col>
        <v-col cols="9">
          <v-text-field
            label="產品最低手續費"
            required
            v-model="dialogInfo.swapOutServiceFee"
            :rules="serviceFeeRule"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">產品手續費百分比</v-col>
        <v-col cols="9">
          <v-text-field
            label="產品手續費百分比"
            required
            v-model="dialogInfo.swapOutServiceFeePercentage"
            :rules="serviceFeePercentageRule"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">回饋百分比</v-col>
        <v-col cols="9">
          <v-text-field
            label="回饋百分比"
            required
            v-model="dialogInfo.pointBackPercentage"
            :rules="servicePointBackPercentageRule"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">兌換連結</v-col>
        <v-col cols="9">
          <v-text-field label="兌換連結" required v-model="dialogInfo.link" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">附加參數</v-col>
        <v-col cols="9">
          <v-textarea
            outlined
            label="附加參數"
            v-model="dialogInfo.additionalParameters"
            :rules="isJsonObjectRule"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">圖片
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-icon color="black" small dark v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <span>尺寸比例為 120*120</span>
          </v-tooltip>
        </v-col>
        <v-col cols="9">
          <v-row>
            <v-col cols="6">
              <v-file-input
                :rules="fileRules"
                @click:clear="clearImage"
                @change="changePic($event)"
                accept="image/png, image/jpeg, image/bmp"
                placeholder="上傳圖片"
                prepend-icon="mdi-camera"
                label=""
              ></v-file-input>
            </v-col>
            <v-col cols="6">
              <img class="preview" :src="pic" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">自行標記票券狀態</v-col>
        <v-col cols="9">
          <v-simple-checkbox
            v-model="dialogInfo.canUserChangeStatusOfVoucher"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Email</v-col>
        <v-col cols="9">
          <v-text-field
            label="Email"
            :rules="[(v) => !v || v.length < 300 || 'Email要小於300字']"
            v-model="dialogInfo.email"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">禁止使用的支付(多選)</v-col>
        <v-col cols="9">
          <v-select
            label="禁止使用的支付"
            :items="paymentMethods"
            item-text="name"
            item-value="methodId"
            v-model="dialogInfo.notAvailablePaymentMethods"
            multiple
            :clearable="true"
          >
          </v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" align="end">
          <v-btn class="ma-2" @click="cancel">取消</v-btn>
          <v-btn class="ma-2" :loading="loading" type="submit">儲存</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import itemMixin from '@/minix/itemMixin';
import ruleMixin from '@/minix/ruleMixin';
import imageConvert from '@/utils/image';
import { mapState } from 'vuex';

export default {
  mixins: [itemMixin, ruleMixin],
  props: {
    merchantCode: {
      type: String,
    },
    merchantName: {
      type: String,
    },
    categoryId: {
      type: String,
    },
    link: {
      type: String,
    },
    merchantPic: {
      type: String,
    },
    displayType: {
      type: Number,
    },
    voucherGenerationMethod: {
      type: Number,
    },
    swapOutServiceFee: {
      type: Number,
    },
    swapOutServiceFeePercentage: {
      type: Number,
    },
    pointBackPercentage: {
      type: Number,
    },
    additionalParameters: {
      type: String,
    },
    canUserChangeStatusOfVoucher: {
      type: Boolean,
      default: false,
    },
    email: {
      type: String,
    },
    notAvailablePaymentMethods: {
      type: Array,
    },
    isAnyProducts: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      valid: true,
      VoucherGenerationMethods: [
        { value: 1, text: '預先產生' },
        { value: 2, text: '當交易時產生' },
      ],
      dialogInfo: {
        merchantCode: null,
        merchantName: null,
        categoryId: null,
        link: null,
        merchantPic: null,
        displayType: 1,
        voucherGenerationMethod: null,
        swapOutServiceFee: null,
        swapOutServiceFeePercentage: null,
        pointBackPercentage: null,
        additionalParameters: null,
        canUserChangeStatusOfVoucher: false,
        email: null,
        notAvailablePaymentMethods: null,
      },
      isJsonObjectRule: [
        (v) => {
          let isJson = false;
          if (v) {
            try {
              isJson = typeof JSON.parse(v) === 'object';
            } catch {
              isJson = false;
            }
          }
          return !v || isJson || '必須是JSON格式內容';
        },
      ],
      merchantNameRule: this.requiredRule('供應商名稱'),
      merchantCodeRule: this.requiredRule('供應商代碼'),
      serviceFeeRule: this.getNumberRule('手續費'),
      serviceFeePercentageRule: this.getNumberRule('手續費百分比'),
      servicePointBackPercentageRule: this.getNumberRule('回饋百分比'),
      typeRule: [(v) => !!v || v === 0 || v === 1 || v === 2 || '類別 為必填'],
      pic: '',
    };
  },
  watch: {
    inputs(v) {
      this.dialogInfo = v;
    },
    merchantPic(v) {
      this.pic = v;
    },
    voucherGenerationMethod(v) {
      if (v === 3) {
        this.VoucherGenerationMethods.push({ value: 3, text: '兩者' });
      }
    },
  },
  computed: {
    ...mapState({
      voucherDisplayTypes: (state) => state.merchant.voucherDisplayTypes,
      paymentMethods: (state) => state.paymentMethod.paymentMethods,
    }),
    categorySelectForm() {
      return this.merchantCategories.map((p) => ({
        text: p.categoryName,
        value: p.categoryId,
      }));
    },
    fileRules() {
      return [
        (v) => !!v || !!this.pic || '檔案 為必填',
        (v) => !v || v.size < 4000000 || '照片大小不可大於 4 MB!',
      ];
    },
    inputs() {
      return {
        merchantCode: this.merchantCode,
        merchantName: this.merchantName,
        categoryId: this.categoryId,
        link: this.link,
        merchantPic: this.merchantPic,
        displayType: this.displayType,
        voucherGenerationMethod: this.voucherGenerationMethod,
        swapOutServiceFee: this.swapOutServiceFee,
        swapOutServiceFeePercentage: this.swapOutServiceFeePercentage,
        pointBackPercentage: this.pointBackPercentage,
        additionalParameters: this.additionalParameters,
        canUserChangeStatusOfVoucher: this.canUserChangeStatusOfVoucher,
        email: this.email,
        notAvailablePaymentMethods: this.notAvailablePaymentMethods,
      };
    },
  },
  methods: {
    getNumberRule(text) {
      return [
        (v) => /^[0-9]*$/.test(v) || `${text} 必須是數字`,
        (v) => v !== '' || `${text} 為必填`,
      ];
    },
    clearImage() {
      this.pic = '';
    },
    changePic(event) {
      if (event) {
        this.dialogInfo.merchantPic = event;
        this.pic = URL.createObjectURL(event);
      }
    },
    async submit() {
      if (!this.$refs.form.validate()) return;
      const submitData = { ...this.dialogInfo };
      submitData.merchantPic = await imageConvert(this.dialogInfo.merchantPic);

      this.$emit('submit', submitData);
    },
    async cancel() {
      await this.$router.back();
    },
  },
};
</script>

<style lang="sass" scoped>
img
  max-width: 100%
</style>
